import React from 'react';
import PropTypes from 'prop-types';
import InfoIcon from 'material-ui/svg-icons/action/info-outline';
import styled from 'styled-components';

const StyledWrapper = styled.div`
    position: fixed;
    bottom: 15px;
    left: 15px;
`;

const StyledInner = styled.div`
    display: flex;
    width: 325px;
    align-items: center;
    justify-content: flex-start;
`;

const StyledIcon = styled.div`
    height: 24px;
    width: 24px;
    margin-right: 10px;
`;

const StyledMessage = styled.div`
    font-size: 15px;
    font-style: italic;
`;

const BookingAmendInformation = (props) => {
    const {
        message,
    } = props;

    return (
        <StyledWrapper>
            <StyledInner>
                <StyledIcon>
                    <InfoIcon />
                </StyledIcon>

                <StyledMessage>{ message }</StyledMessage>
            </StyledInner>
        </StyledWrapper>
    );
};

BookingAmendInformation.propTypes = {
    message: PropTypes.string.isRequired,
};

export default BookingAmendInformation;



// WEBPACK FOOTER //
// ./src/pages/bookings/amend/BookingAmendInformation.js